import './search-filter.scss';
import { Icon, withStyles } from '@material-ui/core';
import Slider from '@material-ui/core/Slider';
import { useEffect, useState } from 'react';
import { getSearchFilterItems } from '../../shared/services/search/search-service';
import CheckboxSelect from '../../components/checkbox-Select/checkbox-select';
import Switch from '@material-ui/core/Switch';
import ImageGenerator from '../../components/image-generator/image-generator';
import setting from '../../assets/images/setting-search.svg';
import CloseIcon from '@material-ui/icons/Close';

const DEFAULT_FILTER_ITEMS = {
	q: '',
	types: 'all',
	page: 0,
	size: 30,
	fromYear: '',
	toYear: '',
	fromImdb: 1,
	toImdb: 10,
	isDubbed: false,
	hasSubtitle: false,
	tags: ''
};

const TAGS_ITEMS = {
	category: [],
	country: [],
	genre: [],
	pg: [],
}

const AGES_LIST = {
	AGE_R: "RTNQy",
	AGE_PG13: "TTc3f",
	AGE_PG: "9ptcK",
	AGE_G: "o8HS7",
	AGE_NC17: "ADH1R",
}

const CustomSlider = withStyles({
	root: {
		color: "#3f51b5", // رنگ بک‌گراند
		height: 10, // ضخامت اسلایدر
		marginTop: 2,
		marginBottom: 16,
		paddingTop: 13,
		paddingBottom: 13,
	},
	thumb: {
		height: 20,
		width: 20,
		backgroundColor: "#fff",
		border: "2px solid currentColor",
		marginTop: -8,
		marginLeft: -10,
		"&:focus, &:hover, &$active": {
			boxShadow: "inherit",
		},
	},
	active: {},
	valueLabel: {
		left: "calc(-50%)",
	},
	track: {
		height: 5,
		borderRadius: 5,
	},
	mark: {
		top: 14
	},
	markLabel: {
		top: 26
	},
	rail: {
		height: 5,
		borderRadius: 5,
	},
})(Slider);
function SearchFilter ({props,  onChange }) {
	const [filterAllItems, setFilterAllItems]	   = useState(DEFAULT_FILTER_ITEMS);
	const [tagsItems, setTagsItems]	   			   = useState(TAGS_ITEMS);
	const [typeCalender, setTypeCalender]		   = useState(true);
	const [yearsList, setYearsList]		           = useState([{gregorian: '', jalali: ''}]);
	const [showSetting, setShowSetting]		       = useState(false);

	const adult = [AGES_LIST.AGE_G,AGES_LIST.AGE_PG,AGES_LIST.AGE_PG13, AGES_LIST.AGE_R,AGES_LIST.AGE_NC17];
	const teen = [AGES_LIST.AGE_G,AGES_LIST.AGE_PG,AGES_LIST.AGE_PG13];
	const kid = [AGES_LIST.AGE_G];

	useEffect(() => {
		createYearsList();
		getSearchFilterItems().then(
			(res) => {
				if (res.data.code === 200) {
					setTagsItems(res.data.data);
				}
			}
		).catch(() => {})

	}, []);

	useEffect(() => {
		setFilterAllItems(prevFilterAllItems => ({ ...prevFilterAllItems, q: (props) ? props : '' }));
	}, [props]);

	useEffect(() => {
	}, [filterAllItems]);

	const removeFirstComma = (str) => {
		if (str[0] === ",") {
			return str.slice(1);
		} else {
			return str;
		}
	};

	const handleCheckboxChange = (selectedOptions) => {
		let tags = filterAllItems.tags;
		if (selectedOptions.type === 'add') {
			let combinedArray;
			if (tags.length === 0) {
				combinedArray =  [...filterAllItems.tags, ...selectedOptions.value];
			} else {
				combinedArray =  [...filterAllItems.tags.split(","), ...selectedOptions.value];
			}

			const uniqueCombinedArray = [...new Set(combinedArray)];
			const tagsString = uniqueCombinedArray.join(",");

			setFilterAllItems(prevFilterAllItems => ({ ...prevFilterAllItems, tags: tagsString }));
		} else {

			// If the preceding value had a (,), it will also be removed.
			const regex = new RegExp(`,?\\s*${selectedOptions?.value}\\b`, 'g');

			tags = tags.replace(regex, '')
			setFilterAllItems(prevFilterAllItems => ({
				...prevFilterAllItems,
				tags: tags}));
		}
	};

	const handelTypesChange = (type) => {
		setFilterAllItems((prevFilterAllItems) => ({
			...prevFilterAllItems,
			types: type
		}));
	}

	const removeAge = (mainList, listB) => {
		return mainList.filter((item) => {
			return !listB.includes(item);
		});
	}

	const findUniqueList = (mainList) => {
		let count = 0;
		adult.forEach((item) => {
			if (mainList.includes(item)) {
				count++;
			}

		});
		return count;
	}

	const createYearsList = () => {
		const currentYear = new Date().getFullYear();
		const yearsList = [];

		for (let i = currentYear; i >= currentYear - 50; i--) {
			const gregorianDate = new Date(i, 0, 1);
			const gregorianYear = gregorianDate.toLocaleDateString('en-US', { year: 'numeric', calendar: 'gregory' });

			const jalaliDate = new Date(i, 0, 1);
			const jalaliYear = jalaliDate.toLocaleDateString('fa-IR', { year: 'numeric', calendar: 'persian', numberingSystem: 'latn' });

			yearsList.push({
				gregorian: gregorianYear,
				jalali: jalaliYear,
			});
		}

		setYearsList(yearsList);
	};

	const handelAgeChange = (age) => {
		let tags = filterAllItems.tags;
		const hasUniqueList = findUniqueList(tags.split(","));

		if (age.length !== hasUniqueList) {

			// reset ages
			const otherItems = removeAge(tags.split(","), adult);
			setFilterAllItems(prevItems => ({
				...prevItems,
				tags: otherItems.join(",")}));

			let combinedArray;
			if (tags.length === 0) {
				combinedArray =  [...otherItems, ...age];
			} else {
				combinedArray =  [...otherItems, ...age];
			}

			const uniqueCombinedArray = [...new Set(combinedArray)];
			const tagsString = uniqueCombinedArray.join(",");

			setFilterAllItems(prevFilterAllItems => ({ ...prevFilterAllItems, tags: tagsString }));
		} else {
			const otherItems = removeAge(tags.split(","), adult);
			setFilterAllItems(prevFilterAllItems => ({
				...prevFilterAllItems,
				tags: otherItems.join(",")}));
		}
	}

	const toggleTypeCalender = () => {
		setFilterAllItems((prevFilter) => ({
			...prevFilter,
			fromYear: '',
			toYear: ''
		}))
		setTypeCalender((prev) => !prev);
		document.querySelector('.from-select-year').selectedIndex = 0;
		document.querySelector('.to-select-year').selectedIndex = 0;
	};

	const handleOtherFilter = (name, value) => {
		return () => {
			setFilterAllItems(prevState => ({
				...prevState,
				[name]: !value
			}));
		};
	};

	const handleFromYearChange = (event) => {
		setFilterAllItems((prevFilter) => ({
			...prevFilter,
			fromYear: event.target.value,
		}));
	};

	const handleToYearChange = (event) => {
		setFilterAllItems((prevFilter) => ({
			...prevFilter,
			toYear: event.target.value,
		}));
	};

	const handleChange = (event, newValue) => {
		setFilterAllItems((prevFilter) => ({
			...prevFilter,
			fromImdb: newValue[0],
			toImdb: newValue[1],
		}));
	};

	const sendFilterItems = () => {
		setShowSetting(false)
		setFilterAllItems(prevFilterAllItems =>
			({
				...prevFilterAllItems,
				tags: removeFirstComma(prevFilterAllItems.tags)
			}));
		const updateData = JSON.parse(JSON.stringify(filterAllItems));
		updateData.tags = removeFirstComma(updateData.tags);
		onChange({showSetting: false, value: updateData, tagItems: tagsItems});
	}

	const renderFilterBox = () => {
		const reformatGenre = {};
		tagsItems.genre.forEach((data) => {
			reformatGenre[data.id] = data.value;
		});

		const reformatCategory = {};
		tagsItems.category.forEach((data) => {
			reformatCategory[data.id] = data.value;
		});

		const reformatCountry = {};
		tagsItems.country.forEach((data) => {
			reformatCountry[data.id] = data.value;
		});

		const marks = [
			{
				value: 1,
				label: '1',
			},
			{
				value: 2,
			},
			{
				value: 3,
			},
			{
				value: 4,
			},
			{
				value: 5,
			},
			{
				value: 6,
			},
			{
				value: 7,
			},
			{
				value: 8,
			},
			{
				value: 9,
			},
			{
				value: 10,
				label: '10',
			},
		];

		const showSettingHandler = ()=> {
			setShowSetting((prevState)=> {
				onChange({showSetting: !prevState});
				return !prevState;
			})
		}

		return (
			<>
				<div className='handler-filter' onClick={showSettingHandler}>
					<ImageGenerator src={setting} />
				</div>

				<div className={`filter-box${ !showSetting ? ' hide' : '' }`}>
					<div className='limit-selected'>
						<div className='label md-label'>
							نوع
						</div>
						<div className='d-flex'>
							<a className={filterAllItems.types === 'movies' ? 'active' : null} onClick={()=> handelTypesChange('movies')}>فیلم</a>
							<a className={filterAllItems.types === 'series' ? 'active' : null} onClick={()=> handelTypesChange('series')}>سریال</a>
							<a className={filterAllItems.types === 'all' ? 'active' : null} onClick={()=> handelTypesChange('all')}>همه</a>
						</div>
					</div>
					<div className='genre'>
						<CheckboxSelect options={reformatGenre}
										title="ژانر"
										onChange={handleCheckboxChange} />
					</div>

					<div className='category'>
						<CheckboxSelect options={reformatCategory}
										title="دسته بندی"
										onChange={handleCheckboxChange} />
					</div>

					<div className='country'>
						<CheckboxSelect options={reformatCountry}
										title="کشور سازنده"
										onChange={handleCheckboxChange} />
					</div>
					{/*<div className='limit-selected'>*/}
					{/*	<div className='label md-label'>*/}
					{/*		رده سنی*/}
					{/*	</div>*/}
					{/*	<div className='d-flex'>*/}

					{/*		<a className={findUniqueList(filterAllItems.tags.split(",")) === adult.length ? 'active' : null} onClick={()=> handelAgeChange(adult)}>بزرگسال</a>*/}
					{/*		<a className={findUniqueList(filterAllItems.tags.split(",")) === teen.length ? 'active' : null} onClick={()=> handelAgeChange(teen)}>نوجوان</a>*/}
					{/*		<a className={findUniqueList(filterAllItems.tags.split(",")) === kid.length ? 'active' : null ? 'active' : null} onClick={()=> handelAgeChange(kid)}>کودک</a>*/}
					{/*	</div>*/}
					{/*</div>*/}
					<div className="year-box">
						<div className='label md-label'>
							سال ساخت
						</div>
						<div className='type-calender d-flex' style={{padding: '0 24px', alignItems: 'center'}}>
							<label htmlFor='type-calendar'>شمسی</label>
							<Switch color="secondary" checked={typeCalender} onChange={toggleTypeCalender} id="type-calendar" />
							{/*<PinkSwitch {...label} defaultChecked id="type-calendar"/>*/}

							<div className='d-flex' style={{gap: '8px', width: '60%', marginRight:'auto'}}>
								{typeCalender ? (
									<>
										<select className='form-select from-select-year'
												onChange={handleFromYearChange}
												defaultValue={'از سال'}
												aria-label='از سال'>
											<option value="از سال" disabled>از سال</option>
											{yearsList.map((option, index) => (
												<option key={index}
														value={option.jalali}>
													{option.jalali}
												</option>
											))}
										</select>
										<select className="form-select to-select-year"
												onChange={handleToYearChange}
												defaultValue={'تا سال'}
												aria-label="تا سال">
											<option value="تا سال" disabled>تا سال</option>
											{yearsList.map((option, index) => (
												<option key={index}
														value={option.jalali}>
													{option.jalali}
												</option>
											))}
										</select>
									</>
								) : (
									<>
										<select className='form-select from-select-year'
												onChange={handleFromYearChange}
												defaultValue={'از سال'}
												aria-label='از سال'>
											<option value="از سال" disabled>از سال</option>
											{yearsList.map((option, index) => (
												<option key={index}
														value={option.gregorian}>
													{option.gregorian}
												</option>
											))}
										</select>
										<select className="form-select to-select-year"
												onChange={handleToYearChange}
												defaultValue={'تا سال'}
												aria-label="تا سال">
											<option value="تا سال" disabled>تا سال</option>
											{yearsList.map((option, index) => (
												<option key={index}
														value={option.gregorian}>
													{option.gregorian}
												</option>
											))}
										</select>
									</>
								)}
							</div>
						</div>

					</div>
					<div className="rate-box">
						<div className='label md-label'>
							امتیاز
						</div>
						<div className='imdb-slider'>
							<CustomSlider
								defaultValue={1}
								value={[filterAllItems.fromImdb, filterAllItems.toImdb]}
								aria-labelledby="discrete-slider-small-steps"
								step={1}
								marks={marks}
								min={1}
								max={10}
								onChange={handleChange}
								valueLabelDisplay="auto"
							/>
						</div>
					</div>

					<div className="d-flex sub-double" style={{justifyContent: 'space-between'}}>
						<div className='type-calender d-flex' style={{padding: '0 24px', alignItems: 'center'}}>
							<label htmlFor='has-subtitle'>زیرنویس</label>
							<Switch color="secondary" checked={filterAllItems.hasSubtitle}
									onChange={handleOtherFilter('hasSubtitle', filterAllItems.hasSubtitle)}
									id="has-subtitle" />
						</div>
						<div className='type-calender d-flex' style={{padding: '0 24px', alignItems: 'center'}}>
							<label htmlFor='is-dubbed'>دوبله فارسی</label>
							<Switch color="secondary" checked={filterAllItems.isDubbed}
									onChange={handleOtherFilter('isDubbed', filterAllItems.isDubbed)}
									id="is-dubbed" />
						</div>
					</div>

					<div className="submit-filter" style={{padding: '0 24px'}}>
						<button className="button"
								onClick={sendFilterItems}>
							<span>جستجو</span>
						</button>
					</div>
				</div>
			</>
		);
	}

	return (
		renderFilterBox()
	);

}
export default SearchFilter;